import React, { useEffect, useState } from 'react';
import { Container, Stack, Button } from '@mui/material';
import WalletBalance from './components/WalletBalance';
import AddBalanceBox from './components/AddBalanceBox';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
// import { PayByZarinPal } from '../GetNewTurn/Adapters/PayByZarinPal';
import Cookies from 'js-cookie';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Price3DigitSplitter } from 'utils/Price3DigitSplitter';
import GeneralPaymentBackdrop from 'Global/Components/CommonComponents/GeneralPaymentBackdrop/GeneralPaymentBackdrop';
const Wallet = () => {
  const [amount, setAmount] = useState(0);
  const [paymentBackdrop, openPaymentBackdrop] =
    useState(false);

  const increase_balance_label = FindLangKey(
    'genral-public-label-increase-balance'
  );

  const confirm_increase_message = FindLangKey(
    'genral-public-label-confirm-increase-balance'
  );

  const label_tooman = FindLangKey(
    'genral-public-label-tooman'
  );

  const label_pay = FindLangKey(
    'genral-public-label-pay-wallet'
  );

  const wallet = FindLangKey(
    'get-new-turn-payment-based-on-wallet'
  );
  const direct_pay = FindLangKey(
    'get-new-turn-payment-based-on-direct-payment'
  );

  const backwardMsg = FindLangKey('get-new-turn-back-step');
  const continueMsg = FindLangKey(
    'general-public-label-approve'
  );

  const select_portal_label = FindLangKey(
    'get-new-turn-select-payment-label'
  );
  const Zarin_pal_label = FindLangKey(
    'get-new-turn-select-zarin-pal-portal'
  );
  const Saman_kish_label = FindLangKey(
    'get-new-turn-select-saman-kish-pal-portal'
  );

  const price = FindLangKey('freeze-contracts-label-price');

  let currentUrl = window.location.href;
  currentUrl = document.URL;
  currentUrl = new URL(window.location);
  currentUrl = currentUrl.origin;

  const user = JSON.parse(Cookies.get('user'));
  const idPatient = JSON.parse(
    Cookies.get('user')
  )?.IdPatient;

  // PayByZarinPal({
  //   idPatient: idPatient,
  //   amount,
  //   Description: `افزایش موجودی`,
  //   email: user.Email,
  //   mobile: user.Mobile,
  //   callBackLink: `${currentUrl}/pub/VerifyZarinPal`,
  // });

  return (
    <React.Fragment>
      <Container sx={{ mt: '1em' }} maxWidth="md">
        <Stack gap=".5em">
          <WalletBalance />
          <AddBalanceBox setAmount={setAmount} />
          <Button
            disabled={amount === 0}
            variant="contained"
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
            }}
            onClick={() => {
              openPaymentBackdrop(true);
            }}
          >
            {label_pay} 
            {amount
              ? `${Price3DigitSplitter(
                  amount / 10
                )} ${label_tooman}`
              : ''}
          </Button>
        </Stack>
        <GeneralPaymentBackdrop
          openBackdrop={paymentBackdrop}
          setBackdrop={openPaymentBackdrop}
          priceTag={amount}
          labels={{
            price: price,
            selectPortal: select_portal_label,
            Zarin_pal_label: Zarin_pal_label,
            Saman_kish_label: Saman_kish_label,
            backwardMsg: backwardMsg,
            continueMsg: continueMsg,
          }}
        />
      </Container>
    </React.Fragment>
  );
};

export default Wallet;
